/**
 * Live school → stone colors from the School colors Google Sheet tab.
 * JSONP so the storefront can read the sheet without CORS.
 */
(function () {
  var SHEET_URL =
    'https://docs.google.com/spreadsheets/d/1X8X6REpj5ngE4LQNM8XsQfQn54MYuHqjAugkp9L-T5w/gviz/tq' +
    '?tqx=out:json;responseHandler:SJSchoolColorsGviz&sheet=School%20colors';

  var ALLOWED = {
    white: 1,
    ruby: 1,
    garnet: 1,
    blue: 1,
    green: 1,
    black: 1,
    orange: 1,
    yellow: 1,
    purple: 1,
  };

  var ALIAS = {
    red: 'ruby',
    scarlet: 'ruby',
    crimson: 'ruby',
    maroon: 'ruby',
    cardinal: 'ruby',
    gold: 'yellow',
    navy: 'blue',
    onyx: 'black',
  };

  var byName = Object.create(null);
  var ready = false;
  var waiters = [];

  function normToken(raw) {
    var s = String(raw || '')
      .toLowerCase()
      .trim()
      .replace(/[_-]+/g, ' ');
    if (!s) return '';
    if (ALLOWED[s]) return s;
    if (ALIAS[s]) return ALIAS[s];
    return '';
  }

  function normName(raw) {
    return String(raw || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[^a-z0-9&]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cell(row, i) {
    var c = row && row.c && row.c[i];
    return c && c.v != null ? String(c.v).trim() : '';
  }

  function lookup(name) {
    var key = normName(name);
    if (!key) return [];
    if (byName[key]) return byName[key].slice();
    for (var k in byName) {
      if (k === key || k.indexOf(key) !== -1 || key.indexOf(k) !== -1) {
        return byName[k].slice();
      }
    }
    return [];
  }

  function applyTable(table) {
    var rows = (table && table.rows) || [];
    byName = Object.create(null);
    for (var i = 0; i < rows.length; i++) {
      var school = cell(rows[i], 0);
      if (!school || /^school$/i.test(school)) continue;
      var colors = [];
      var a = normToken(cell(rows[i], 1));
      var b = normToken(cell(rows[i], 2));
      if (a && a !== 'white') colors.push(a);
      if (b && b !== 'white' && colors.indexOf(b) === -1) colors.push(b);
      if (!colors.length) continue;
      byName[normName(school)] = colors;
    }
    ready = true;
    waiters.splice(0).forEach(function (fn) {
      try {
        fn(byName);
      } catch (e) {}
    });
    document.dispatchEvent(new CustomEvent('sj-school-colors-ready'));
  }

  window.SJSchoolColorsGviz = function (resp) {
    if (resp && resp.status === 'ok') applyTable(resp.table);
  };

  window.SJSchoolColors = {
    lookup: lookup,
    isReady: function () {
      return ready;
    },
    whenReady: function (fn) {
      if (ready) fn(byName);
      else waiters.push(fn);
    },
  };

  var script = document.createElement('script');
  script.async = true;
  script.src = SHEET_URL;
  script.onerror = function () {
    ready = true;
    waiters.splice(0).forEach(function (fn) {
      try {
        fn(byName);
      } catch (e) {}
    });
  };
  document.head.appendChild(script);
})();
